export default [
  {
    text: 'Global event name assets',
    value: 'name',
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'Created',
    value: 'created_at',
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
  {
    text: 'Platforms',
    value: 'events',
    width: '40%',
    isDefault: true,
    isSelected: true,
    isRequired: false,
  },
];
